module.exports = __webpack_public_path__ + "assets/img/logo.04bbf504.webp";